import { useRouter } from "next/router";
import { useEffect } from "react";
import { Domain } from "../types/common";
import { isDomain } from "../utils/common";

export const useIsPageAllowed = (allowedPages: Domain[], host: string) => {
  const router = useRouter();

  if (!isPageAllowed(allowedPages, host, (router.query.site || "") as string)) {
    useEffect(() => {
      router.replace("/");
    });
    return false;
  }

  return true;
};

function isPageAllowed(allowedPages: Domain[], host: string, query: string) {
  for (const page of allowedPages) {
    if (isDomain(page, host, query)) return true;
  }
  return false;
}
